import { useContext } from "react";
import PerspectivesContext from "../contexts/PerspectivesContext";
const usePerspectives = () => {
  const perspectivesContextValue = useContext(PerspectivesContext);
  if (!perspectivesContextValue) {
    throw new Error("usePerspectives hook needs to be used inside PerspectivesContext.Provider");
  }
  return perspectivesContextValue.availablePerspectives;
};
export default usePerspectives;
